export default __webpack_public_path__ + "static/2-bc52a069ca0265b4aea94060af294607.png";